import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editAnswerList } from '../../../actions/fantasy-yes-no-action-types';
import useGame from '../../../utilities/hooks/game';
import { showToast } from '../../../actions/app-actions-types';
import { isSmartPhone } from '../../../utilities/helper';
import MyAnswerTabWeb from './index_web';
import MyAnswerTabMWeb from './index_mWeb';

const MyAnswerTab = () => {
  const dispatch = useDispatch();
  const { myAnswersList } = useSelector((state: any) => state.fantasy_yes_no);
  const { item: matchItem, language = 'en' } = useGame();
  const [editMode] = useState(true);
  const [answerList, setAnswerList] = useState([] as any);
  const [insightInfoModal, setInsightInfoModal] = useState(false);
  const [ruleModal, setRuleModal] = useState(false);
  const [insight, setInsight] = useState('');
  const [yesNoVideoModal, setYesNoVideoModal] = useState(false);

  useEffect(() => {
    getAnswerList_();
    window.addEventListener('popstate', onClickBrowserBack);

    return () => {
      window.removeEventListener('popstate', onClickBrowserBack);
    };
  }, []);

  const onClickBrowserBack = () => {
    setInsightInfoModal(false);
  };

  const onPressClose = () => {
    setInsightInfoModal(false);
  };

  const onPressInsight = (index: any) => {
    const insightData = answerList[index]?.insights || {};
    const { english = '' } = insightData;
    if (english) {
      setInsight(insightData);
      setInsightInfoModal(true);
    } else {
      dispatch(showToast('There is no data available'));
    }
  };

  const getAnswerList_ = () => {
    let result: any = myAnswersList[matchItem._id];
    setAnswerList(result);
  };

  const onChangeEditMode = () => {
    onChangeEdit();
  };

  const onChangeEdit = () => {
    dispatch(
      editAnswerList({
        ...myAnswersList,
        [matchItem._id]: answerList
      })
    );
    dispatch(showToast('Answer updated successfully'));
  };

  const onChange2x = (index: any) => {
    if (editMode) {
      answerList[index].isPowerUp = !answerList[index].isPowerUp;
      setAnswerList([...answerList]);
    }
  };
  const onChangeMyAnswer = (index: any) => {
    if (editMode) {
      answerList[index].answer = !answerList[index].answer;
      setAnswerList([...answerList]);
    }
  };

  const onPressDismissRule = () => {
    setRuleModal(false);
  };

  const onPressOpenRule = () => {
    setRuleModal(true);
  };

  const onPressOpenYNVideo = () => {
    setYesNoVideoModal(true);
  };

  const onPressDismissYNVideo = () => {
    setYesNoVideoModal(false);
  };

  return (
    <>
      {isSmartPhone ? (
        <MyAnswerTabMWeb
          answerList={answerList}
          editMode={editMode}
          onChange2x={onChange2x}
          onChangeMyAnswer={onChangeMyAnswer}
          language={language}
          onPressInsight={onPressInsight}
          insightInfoModal={insightInfoModal}
          onPressClose={onPressClose}
          insight={insight}
          ruleModal={ruleModal}
          onPressDismissRule={onPressDismissRule}
          yesNoVideoModal={yesNoVideoModal}
          onPressDismissYNVideo={onPressDismissYNVideo}
          onPressOpenRule={onPressOpenRule}
          onPressOpenYNVideo={onPressOpenYNVideo}
          onChangeEditMode={onChangeEditMode}
        />
      ) : (
        <MyAnswerTabWeb
          answerList={answerList}
          editMode={editMode}
          onChange2x={onChange2x}
          onChangeMyAnswer={onChangeMyAnswer}
          language={language}
          onPressInsight={onPressInsight}
          insightInfoModal={insightInfoModal}
          onPressClose={onPressClose}
          insight={insight}
          ruleModal={ruleModal}
          onPressDismissRule={onPressDismissRule}
          yesNoVideoModal={yesNoVideoModal}
          onPressDismissYNVideo={onPressDismissYNVideo}
          onPressOpenRule={onPressOpenRule}
          onPressOpenYNVideo={onPressOpenYNVideo}
          onChangeEditMode={onChangeEditMode}
        />
      )}
    </>
  );
};
export default MyAnswerTab;
